<template>
    <div class="wrapper">
        <div class="box">
            <div class="box-left clearfix">
                <div style="float:left;width:98px;text-align: center;" v-for="(item, _index) in [aboutUs, leaseInstruction, palletBank,mallBusiness,clientService]" :key="_index">
                    <div style="font-weight: bold">{{item.title}}</div>
                    <router-link v-for="(child, index) in item.children" :class="[child.mete?'titleBold':'discolor']" :key="index" tag="div" :to="`/${item.path}/${child.path}`">{{child.text}}</router-link>
                </div>
            </div>
            <ul class="box-right clearfix">
                <li></li>
                <li>
                    <div class="wechat">
                        <div>
                            <img :src="localUtil.imgUrl+'home/public-account-qrcode.jpg'" style="width: 100px" />
                        </div>
                        <p>扫一扫关注普拉托微信公众号</p>
                    </div>
                </li>
                <li>
                    <div>
                        <img :src="localUtil.imgUrl+'home/logo.png'" style="width: 180px" />
                    </div>
                    <h3 style="color:#333">0755-89589212</h3>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>

import { mapState } from "vuex";


export default {
    watch: {
        '$route': function (newVal) {
            if (newVal) {
                document.documentElement.scrollTop = document.body.scrollTop = 0;
            }
        }
    },
    computed: {
        ...mapState('footerRouter', ['aboutUs', 'leaseInstruction', 'palletBank', 'mallBusiness', 'clientService'])
    },
    methods: {
        // clickMenu(item, child) {
        //     this.$store.commit('footerRouter/clickMenu', [item, child]);
        // }
    }

}
</script>

<style lang="less" scoped>
.router-link-active {
    color: #ff9000;
}
.wrapper {
    width: 100%;
    height: 200px;
    background: #f6f5f5;
    margin: 100px 0 40px 0;
    box-shadow: 0px 0px 8px 3px #ccc;
}
.box {
    display: flex;
    width: 1080px;
    margin: 0 auto;
    padding-top: 15px;
    align-items: center;
    justify-content: space-around;
}
.box-left {
    .titleBold {
        font-weight: bold;
        color: #2c3e50;
    }
}
.box-left .box-right {
    flex: 1;
}
.box-right {
    li {
        float: left;
        margin-right: 65px;
    }
    li:nth-child(1) {
        width: 1px;
        height: 155px;
        background: #000000;
        margin-left: 30px;
    }
    li:nth-child(2) {
        // width: 195px;
        text-align: center;
        .wechat {
            margin-top: 20px;
        }
    }
    li:nth-child(3) {
        margin-top: 48px;
        text-align: center;
    }
}
</style>